module.exports = __webpack_public_path__ + "img/Sorkat_Cercle.e41bc673.png";